import Lottie from "lottie-react";
import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";

const TipsQuest = () => {
  const [isVisible, setIsVisible] = useState(false);
  const { t } = useTranslation();

  useEffect(() => {
    const isFirstLogin = localStorage.getItem("isFirstLogin");

    if (isFirstLogin === "true") {
      localStorage.setItem("showQuestTips", "true");
      setIsVisible(true);
    } else {
      const shouldShowTips = localStorage.getItem("showQuestTips");
      if (shouldShowTips === "true") {
        setIsVisible(true);
      }
    }
  }, []);

  const handleClose = () => {
    setIsVisible(false);
    localStorage.setItem("isFirstLogin", "false");
    localStorage.setItem("showQuestTips", "false");
  };

  if (!isVisible) return null;

  return (
    <div className="w-full max-w-[368px]">
      <div className="bg-[#ECEEFF] rounded-md p-[18px] h-[267px] relative">
        <div className="mb-2 xs:mb-[18px]">
          <h2 className="text-primary text-2xl leading-7 font-bold">{t("tips.questTitle")}</h2>
          <div
            className="absolute top-[18px] right-[18px] size-6 flex justify-center items-center"
            onClick={handleClose}
          >
            <span className="icon icon-close-1 text-[10px] text-primary/25" />
          </div>
        </div>

        <p className="text-primary text-base font-medium w-auto max-w-[300px]">
          {t("tips.questBody")}
        </p>
        <div className="w-[175px] absolute bottom-0 right-0">
          <Lottie
            loop={false}
            animationData={require("../../../images/animation/ani-take-quest.json")}
            style={{ width: "100%", height: "auto" }}
          />
        </div>
      </div>
    </div>
  );
};

export default TipsQuest;
